import sharedModule from '../../shared.module';
import template from './asLoadingIcon.component.html';
import style from './asLoadingIcon.component.scss';

export default sharedModule.component('asLoadingIcon', {
    template: template,
    style: style,
    bindings: {
        show: '<'
    }
});



// WEBPACK FOOTER //
// ./modules/shared/components/asLoadingIcon/asLoadingIcon.component.js